import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from '../messages';
import SaveBar from '../../components/save-bar';
import { NoGoogleConnectionsContent } from './components/no-google-connections-content';
import { GoogleConnectionsContent } from './components/google-connections-content';
import commonStyles from '../../settings-page.module.less';
import GoogleContextProvider, { GoogleContext } from './context';
import style from '../style.module.less';
import GoogleLogo from '../svgs/google-logo.svg';

const GoogleContentWrapper = () => {
  const { formatMessage } = useIntl();
  const { isGoogleConnected, onSave } = useContext(GoogleContext);
  return (
    <React.Fragment>
      <div className={commonStyles.content}>
        <div className={style['google-wrapper']}>
          <img alt={formatMessage(messages.googleLogo)} className={style.googleLogo} src={GoogleLogo} />
          {isGoogleConnected ? (
            <h3>
              <FormattedMessage {...messages.googleHeaderName} />
            </h3>
          ) : (
            <div />
          )}
          {isGoogleConnected ? <GoogleConnectionsContent /> : <NoGoogleConnectionsContent />}
        </div>
        {isGoogleConnected && <SaveBar className={style['google-save-btn']} onSave={onSave} />}
      </div>
    </React.Fragment>
  );
};

export const GooglePage = () => {
  return (
    <GoogleContextProvider>
      <GoogleContentWrapper />
    </GoogleContextProvider>
  );
};
